import { ReduceStore } from 'flux/utils';
import Dispatcher from '../dispatcher';
import ACTION_TYPES from '../constants/action_types';
import { actions } from '../constants/free_mobile_fitting_light_box/actions';

class CatalogDeliveryInfoLightBoxClass extends ReduceStore {
    getInitialState() {
        return {
            visible: false,
            showFreeShipping: false,
        };
    }

    reduce( state, { source, action } ) {
        const { type, payload } = action;

        if (source === ACTION_TYPES.CATALOG_DELIVERY_INFO_LIGHT_BOX_ACTION) {
            switch ( type ) {
                case actions.SHOW:
                    if ( !state.visible ) {
                        if (payload) {
                            state.showFreeShipping = true;
                        }
                        state.visible = true;
                        this.__emitChange();
                    }
                    break;

                case actions.HIDE:
                    if ( state.visible ) {
                        state.showFreeShipping = false;
                        state.visible = false;
                        this.__emitChange();
                    }
                    break;
            }
        }

        return state;
    }
}

const CatalogDeliveryInfoLightBoxStore = new CatalogDeliveryInfoLightBoxClass( Dispatcher );
export { CatalogDeliveryInfoLightBoxStore };
